import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ClickOutSideDirective } from '@app/shared/directives/click-out-side.directive';
import { WalletSelectList } from '@app/shared/models';
import { TcCurrencyPipe } from '@app/shared/pipes';

@Component({
    selector: 'tc-select-currency-in-input',
    imports: [
        CommonModule,
        TcCurrencyPipe,
        ClickOutSideDirective
    ],
    templateUrl: './select-currency-in-input.component.html',
    styleUrls: ['./select-currency-in-input.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectCurrencyInInputComponent implements OnInit, OnChanges {
    @Output() selectedItemEmit = new EventEmitter<any>();
    @Input() url: string;
    @Input() wallets: WalletSelectList[];
    selected;
    // boolean
    showList: boolean;
    constructor() {

    }
    ngOnChanges(changes: SimpleChanges): void {
     
    }
    ngOnInit(): void {
        if (this.wallets && this.wallets.length > 0) {
            this.selected = this.wallets[0];
            this.selectedItemEmit.emit(this.selected);
        } 
    }

    selectItem(item: any): void {
        this.selected = item;
        this.selectedItemEmit.emit(item)
    }


    toggle(): void {
        this.showList = !this.showList;
    }

    hideList(e): void {
        this.showList = false;
    }


}
